// extracted by mini-css-extract-plugin
export default {"wrapper":"_b6d28591"};